// Category tree: L1 (main) → L2 (sub-categories)
// Keys map to i18n translation keys

export interface SubCategory {
  key: string;
  emoji: string;
}

export interface Category {
  key: string;    // L1 key (maps to categories.* in i18n)
  emoji: string;
  color: string;  // Tailwind color classes
  subs: SubCategory[];
}

export const CATEGORIES: Category[] = [
  {
    key: 'hair',
    emoji: '✂️',
    color: 'bg-rose-100 dark:bg-rose-950/40 text-rose-600 dark:text-rose-400 border-rose-200 dark:border-rose-800',
    subs: [
      { key: 'haircut', emoji: '✂️' },
      { key: 'coloring', emoji: '🎨' },
      { key: 'balayage', emoji: '🌟' },
      { key: 'keratin', emoji: '💎' },
      { key: 'blowout', emoji: '💨' },
      { key: 'extensions', emoji: '🌿' },
    ],
  },
  {
    key: 'nails',
    emoji: '💅',
    color: 'bg-amber-100 dark:bg-amber-950/40 text-amber-600 dark:text-amber-400 border-amber-200 dark:border-amber-800',
    subs: [
      { key: 'gel_manicure', emoji: '💅' },
      { key: 'nail_extensions', emoji: '🔮' },
      { key: 'pedicure', emoji: '🦶' },
      { key: 'nail_design', emoji: '🎨' },
      { key: 'nail_removal', emoji: '🧹' },
    ],
  },
  {
    key: 'lashes',
    emoji: '👁️',
    color: 'bg-emerald-100 dark:bg-emerald-950/40 text-emerald-600 dark:text-emerald-400 border-emerald-200 dark:border-emerald-800',
    subs: [
      { key: 'lash_extensions', emoji: '👁️' },
      { key: 'lash_lamination', emoji: '✨' },
      { key: 'brow_design', emoji: '🎭' },
      { key: 'brow_permanent', emoji: '🖊️' },
      { key: 'brow_lamination', emoji: '🌊' },
    ],
  },
  {
    key: 'makeup',
    emoji: '💄',
    color: 'bg-purple-100 dark:bg-purple-950/40 text-purple-600 dark:text-purple-400 border-purple-200 dark:border-purple-800',
    subs: [
      { key: 'evening_makeup', emoji: '🌙' },
      { key: 'wedding_makeup', emoji: '👰' },
      { key: 'permanent_makeup', emoji: '🖊️' },
      { key: 'airbrush', emoji: '🎨' },
    ],
  },
  {
    key: 'massage',
    emoji: '🤲',
    color: 'bg-blue-100 dark:bg-blue-950/40 text-blue-600 dark:text-blue-400 border-blue-200 dark:border-blue-800',
    subs: [
      { key: 'classic_massage', emoji: '🤲' },
      { key: 'lymph_massage', emoji: '💧' },
      { key: 'anti_cellulite', emoji: '⚡' },
      { key: 'sport_massage', emoji: '🏃' },
      { key: 'stone_massage', emoji: '🪨' },
    ],
  },
  {
    key: 'cosmetology',
    emoji: '🌿',
    color: 'bg-stone-100 dark:bg-stone-900 text-stone-600 dark:text-stone-300 border-stone-200 dark:border-stone-700',
    subs: [
      { key: 'smas_lifting', emoji: '⚡' },
      { key: 'lpg', emoji: '🔬' },
      { key: 'microcurrents', emoji: '💫' },
      { key: 'peeling', emoji: '🌸' },
      { key: 'cleansing', emoji: '✨' },
      { key: 'botox', emoji: '💉' },
      { key: 'hyaluronic', emoji: '💧' },
      { key: 'mesotherapy', emoji: '🔬' },
      { key: 'biorevitalization', emoji: '🌱' },
    ],
  },
  {
    key: 'laser',
    emoji: '⚡',
    color: 'bg-cyan-100 dark:bg-cyan-950/40 text-cyan-600 dark:text-cyan-400 border-cyan-200 dark:border-cyan-800',
    subs: [
      { key: 'diode_laser', emoji: '🔷' },
      { key: 'alexandrite', emoji: '💠' },
      { key: 'elos', emoji: '✨' },
      { key: 'ipl', emoji: '🌟' },
    ],
  },
  {
    key: 'tattoo',
    emoji: '🖊️',
    color: 'bg-indigo-100 dark:bg-indigo-950/40 text-indigo-600 dark:text-indigo-400 border-indigo-200 dark:border-indigo-800',
    subs: [
      { key: 'realism_tattoo', emoji: '🎭' },
      { key: 'geometric_tattoo', emoji: '📐' },
      { key: 'watercolor_tattoo', emoji: '🎨' },
      { key: 'minimalism_tattoo', emoji: '✏️' },
    ],
  },
  {
    key: 'piercing',
    emoji: '💎',
    color: 'bg-pink-100 dark:bg-pink-950/40 text-pink-600 dark:text-pink-400 border-pink-200 dark:border-pink-800',
    subs: [
      { key: 'ear_piercing', emoji: '👂' },
      { key: 'nose_piercing', emoji: '👃' },
      { key: 'body_piercing', emoji: '💎' },
    ],
  },
  {
    key: 'apparatus',
    emoji: '🔬',
    color: 'bg-sky-100 dark:bg-sky-950/40 text-sky-600 dark:text-sky-400 border-sky-200 dark:border-sky-800',
    subs: [
      { key: 'smas_lifting', emoji: '⚡' },
      { key: 'lpg', emoji: '🔬' },
      { key: 'rf_lifting', emoji: '📡' },
      { key: 'cryotherapy', emoji: '❄️' },
      { key: 'led_therapy', emoji: '💡' },
      { key: 'microcurrents', emoji: '💫' },
      { key: 'microdermabrasion', emoji: '✨' },
      { key: 'cavitation', emoji: '🌊' },
    ],
  },
  {
    key: 'injections',
    emoji: '💉',
    color: 'bg-rose-100 dark:bg-rose-950/40 text-rose-600 dark:text-rose-400 border-rose-200 dark:border-rose-800',
    subs: [
      { key: 'botox', emoji: '💉' },
      { key: 'hyaluronic', emoji: '💧' },
      { key: 'mesotherapy', emoji: '🔬' },
      { key: 'biorevitalization', emoji: '🌱' },
      { key: 'prp_therapy', emoji: '🩸' },
      { key: 'lip_augmentation', emoji: '👄' },
      { key: 'contour_plastics', emoji: '✨' },
    ],
  },
  {
    key: 'fitness',
    emoji: '🏋️',
    color: 'bg-lime-100 dark:bg-lime-950/40 text-lime-600 dark:text-lime-400 border-lime-200 dark:border-lime-800',
    subs: [
      { key: 'yoga', emoji: '🧘' },
      { key: 'pilates', emoji: '🤸' },
      { key: 'personal_training', emoji: '💪' },
      { key: 'crossfit', emoji: '🏋️' },
      { key: 'swimming', emoji: '🏊' },
      { key: 'dance', emoji: '💃' },
      { key: 'stretching', emoji: '🧘‍♀️' },
      { key: 'group_fitness', emoji: '👥' },
    ],
  },
  {
    key: 'nutrition',
    emoji: '🥗',
    color: 'bg-green-100 dark:bg-green-950/40 text-green-600 dark:text-green-400 border-green-200 dark:border-green-800',
    subs: [
      { key: 'diet_consultation', emoji: '🥗' },
      { key: 'meal_plan', emoji: '📋' },
      { key: 'sports_nutrition', emoji: '🏃' },
      { key: 'weight_management', emoji: '⚖️' },
      { key: 'clinical_nutrition', emoji: '🩺' },
    ],
  },
  {
    key: 'podology',
    emoji: '🦶',
    color: 'bg-teal-100 dark:bg-teal-950/40 text-teal-600 dark:text-teal-400 border-teal-200 dark:border-teal-800',
    subs: [
      { key: 'medical_pedicure', emoji: '🦶' },
      { key: 'ingrown_nail', emoji: '🩹' },
      { key: 'foot_care', emoji: '🧴' },
      { key: 'diabetic_foot', emoji: '🩺' },
    ],
  },
  {
    key: 'barber',
    emoji: '💈',
    color: 'bg-slate-100 dark:bg-slate-900 text-slate-600 dark:text-slate-300 border-slate-200 dark:border-slate-700',
    subs: [
      { key: 'mens_haircut', emoji: '💈' },
      { key: 'beard_trim', emoji: '🧔' },
      { key: 'hot_shave', emoji: '🪒' },
      { key: 'kids_haircut', emoji: '🧒' },
    ],
  },
  {
    key: 'tanning',
    emoji: '🌅',
    color: 'bg-orange-100 dark:bg-orange-950/40 text-orange-600 dark:text-orange-400 border-orange-200 dark:border-orange-800',
    subs: [
      { key: 'spray_tan', emoji: '💦' },
      { key: 'solarium', emoji: '☀️' },
      { key: 'tan_prep', emoji: '🧴' },
    ],
  },
  {
    key: 'other',
    emoji: '📝',
    color: 'bg-gray-100 dark:bg-gray-900 text-gray-600 dark:text-gray-300 border-gray-200 dark:border-gray-700',
    subs: [],
  },
];

export const CATEGORY_MAP = Object.fromEntries(CATEGORIES.map(c => [c.key, c]));

// Haversine distance formula (returns km)
export function getDistanceKm(
  lat1: number, lng1: number,
  lat2: number, lng2: number
): number {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) *
    Math.cos((lat2 * Math.PI) / 180) *
    Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
